import * as React from 'react';
import { Animator } from 'wix-animations';
import * as DataHooks from '../../consts/data-hooks' ;

export const HeightAnimationContainer = (props: { shouldDisplay: boolean, children }) => {
  const { shouldDisplay, children } = props;
  return <Animator show={shouldDisplay} height dataHook={DataHooks.HEIGHT_ANIMATOR}>
    {children}
  </Animator>;
};
